/**
 * Atmospheric Layers
 *
 * Renders the base atmosphere: gradient, vignette, candle glow, paper grain.
 * All layers are fixed-position, pointer-events: none, and z-indexed below content.
 */

import React from 'react';

export type AtmosphereVariant = 'standard' | 'dimmed' | 'warmer' | 'open-sky';

interface AtmosphericLayersProps {
  variant?: AtmosphereVariant;
}

export const AtmosphericLayers: React.FC<AtmosphericLayersProps> = ({ variant = 'standard' }) => {
  const wrapperClass = variant !== 'standard' ? `atmosphere-${variant}` : undefined;

  const layers = (
    <>
      <div className="atmosphere" />
      <div className="vignette" />
      <div className="candle-glow" />
      <div className="paper-grain" />
    </>
  );

  // Wrap in a variant class so page CSS can override atmospheric values
  if (wrapperClass) {
    return <div className={wrapperClass}>{layers}</div>;
  }

  return layers;
};
